import { useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import useTicketForm from '../../hooks/useTicketForm';
import { useTicketsContext } from '../../context/TicketContext';

export default function EditTicket() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token, user } = useAuth();
  const { dispatch } = useTicketsContext();

  const {
    form,
    setForm,
    error,
    setError,
    handleChange,
    handleFileChange,
  } = useTicketForm();

  useEffect(() => {
    const loadTicket = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/tickets/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setForm({
          ...res.data,
          attachments: [],
          remark: res.data.remark || '',
        });
      } catch (err) {
        setError('Failed to load ticket');
      }
    };

    if (token) loadTicket();
  }, [id, token, setForm, setError]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('subject', form.subject);
      formData.append('description', form.description);
      formData.append('priority', form.priority);

      if (user?.role === 'IT') {
        formData.append('status', form.status);
        formData.append('remark', form.remark || '');
      }

      for (let file of form.attachments) {
        if (file) {
          formData.append('attachments', file);
        }
      }


//console.log(formData);

      const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/tickets/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      dispatch({ type: 'UPDATE_TICKET', payload: res.data });
      navigate('/tickets');
    } catch (err) {
      setError('Update failed');
    }
  };

  if (!token) return <p>Please log in to edit tickets.</p>;

  return (
    <div className="container mt-4">
      <h2>Edit Ticket</h2>
      {error && <p className="text-danger">{error}</p>}
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="mb-3">
          <label className="form-label">Subject</label>
          <input
            type="text"
            name="subject"
            className="form-control"
            value={form.subject}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            name="description"
            className="form-control"
            value={form.description}
            onChange={handleChange}
          ></textarea>
        </div>
        <div className="mb-3">
          <label className="form-label">Priority</label>
          <select
            name="priority"
            className="form-select"
            value={form.priority}
            onChange={handleChange}
          >
            <option>Low</option>
            <option>Medium</option>
            <option>High</option>
          </select>
        </div>
        {user?.role === 'IT' && (
          <>
            <div className="mb-3">
              <label className="form-label">Status</label>
              <select
                name="status"
                className="form-select"
                value={form.status}
                onChange={handleChange}
              >
                <option>Open</option>
                <option>In Progress</option>
                <option>Closed</option>
                <option>Waiting for Approval</option>
                <option>Canceled</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Remark</label>
              <textarea
                name="remark"
                className="form-control"
                value={form.remark || ''}
                onChange={handleChange}
              ></textarea>
            </div>
          </>
        )}
        <div className="mb-3">
          <label className="form-label">Attachments</label>
          <input
            type="file"
            name="attachments"
            className="form-control"
            multiple
            onChange={handleFileChange}
          />
        </div>
        <button type="submit" className="btn btn-primary mr-4">
          Update Ticket
        </button>
      </form>
      
      <Link to="/tickets" className="btn btn-sm btn-outline-secondary mt-2">Back</Link>
    </div>
  );
}
